import { defineMessages } from 'react-intl-next';

// Messages for two people
export const messages = defineMessages({
	othersDoubleWorkedOn: {
		id: 'ptc-directory.team-profile-page.team-work.double.others.worked',
		defaultMessage: '{name1} and {name2} have both worked on this',
		description:
			'This message appears in work list area of the user profile page' +
			'and indicate when two users that arent you worked on an object',
	},
	youDoubleWorkedOn: {
		id: 'ptc-directory.team-profile-page.team-work.double.you.worked',
		defaultMessage: 'You and {name1} have both worked on this',
		description:
			'This message appears in work list area of the user profile page' +
			'and indicate when two users including the current user worked on an object',
	},
	// Messages for three people
	othersTripleWorkedOn: {
		id: 'ptc-directory.team-profile-page.team-work.triple.others.worked',
		defaultMessage: '{name1}, {name2}, and {name3} have all worked on this',
		description:
			'This message appears in work list area of the user profile page' +
			'and indicate when three users that arent you worked on an object',
	},
	youTripleWorkedOn: {
		id: 'ptc-directory.team-profile-page.team-work.triple.you.worked',
		defaultMessage: 'You, {name1}, and {name2} have all worked on this',
		description:
			'This message appears in work list area of the user profile page' +
			'and indicate when three users including the current user worked on an object',
	},
});
